const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
const iosPlatforms = ['iPhone', 'iPad', 'iPod'];

export const OS = {
  WINDOWS: 'Windows',
  MAC: 'Mac',
  IOS: 'iOS',
  ANDROID: 'Android',
  LINUX: 'Linux',
  UNKNOWN: 'Unknown',
};

export const getOperatingSystem = () => {
  const { userAgent, platform } = window.navigator;

  if (macosPlatforms.indexOf(platform) !== -1) {
    return OS.MAC;
  }
  if (iosPlatforms.indexOf(platform) !== -1) {
    return OS.IOS;
  }
  if (windowsPlatforms.indexOf(platform) !== -1) {
    return OS.WINDOWS;
  }
  if (/Android/.test(userAgent)) {
    return OS.ANDROID;
  }
  if (/Linux/.test(platform)) {
    return OS.LINUX;
  }

  return OS.UNKNOWN;
}
